import { PaymentMethodCard } from "./PaymentMethodCard";
import { PaymentMethodResp } from "../Data/ApiTypes";
import { countPaymentMethodSubscriptions } from "../Data/Subscription";
import { PaymentMethodUsBankAccount } from "./PaymentMethodUsBankAccount";

interface PaymentMethodDisplayProps {
    method:    PaymentMethodResp;
    className?: string;
}

interface PaymentMethodUnknownProps {
    method:      PaymentMethodResp;
    activeCount?: number;
}

export function PaymentMethodUnknown( { method, activeCount = 0 }: PaymentMethodUnknownProps ) {
    const isUsed = activeCount > 0;
    return (
        <div className="d-flex flex-column p-3 rounded-3 bg-white"
             style={{ width: 170, minHeight: 110, border: "1px solid #e8e8e8", boxShadow: "0 1px 4px rgba(0,0,0,0.07)" }}>
            <div className="fw-semibold mb-2" style={{ fontSize: "0.85rem", textTransform: "uppercase" }}>
                {method.type.replace( "_", " " )}
            </div>
            <div className="mt-auto">
                {isUsed ? (
                    <span className="px-2 py-1 rounded-pill fw-semibold"
                          style={{ fontSize: "0.7rem", background: "#d1fae5", color: "#065f46" }}>
                        {activeCount} active
                    </span>
                ) : (
                    <span className="px-2 py-1 rounded-pill fw-semibold"
                          style={{ fontSize: "0.7rem", background: "#f1f1f1", color: "#888" }}>
                        Unused
                    </span>
                )}
            </div>
        </div>
    );
}

export function PaymentMethodDisplay( { method, className = "" }: PaymentMethodDisplayProps ) {
    const activeCount = countPaymentMethodSubscriptions( method.subscriptions );
    switch( method.type ) {
        case "card":
            return method.card
                ? <PaymentMethodCard card={method.card} className={className} activeCount={activeCount} />
                : null;
        case "us_bank_account":
            return method.usBankAccount
                ? <PaymentMethodUsBankAccount bankAccount={method.usBankAccount} className={className} activeCount={activeCount} />
                : null;
        default:
            return <PaymentMethodUnknown method={method} activeCount={activeCount} />;
    }
}
